import { DiscountOnEnum } from '@bondsports/types';

export const getDiscountColor = (discountOn: DiscountOnEnum) => {
	return discountOn === DiscountOnEnum.ITEM ? 'navy' : 'teal';
};

export const showRemoveDiscountButton = (discountOn: DiscountOnEnum) => {
	return discountOn === DiscountOnEnum.ITEM;
};

export const isPriceValid = (price: number | null | undefined) => {
	return price !== null && price !== undefined && price >= 0;
};
